export const makeSearchParams = (searchParamsObj: {[x: string]: string | number | undefined | boolean}): string => {
    let searchString = '?';
    Object.entries(searchParamsObj).map(([queryKey, queryValue]) => {
        if(queryValue) {
            searchString += '&' + queryKey + '=' + queryValue;
        }
    });
    return searchString;
};